import React from "react";
import { ExclusionReason } from "@wingspanhq/payments/dist/interfaces";

import { WSText } from "@wingspanhq/fe-component-library";

const defaultExclusionReason = "This form was excluded manually.";

const EXCLUSION_MESSAGES: { [key in ExclusionReason]: string } = {
  [ExclusionReason.BelowThreshold]:
    "This form is excluded because it does not meet the IRS filing threshold of $600 for the year.",
  [ExclusionReason.CompanyStructure]:
    "This form is excluded because the company type doesn't require a 1099-NEC to be filed",
  [ExclusionReason.NonUsEntity]:
    "This form is excluded because the collaborator is not a US Person"
};

const ExclusionReasonInfo: React.FC<{ reason?: ExclusionReason }> = ({
  reason
}) => (
  <WSText.Heading5 as="div" color="grey600" mt="M">
    {reason ? EXCLUSION_MESSAGES[reason] : defaultExclusionReason}
  </WSText.Heading5>
);

export default ExclusionReasonInfo;
